module.exports = __webpack_public_path__ + "img/google-plus-squared.cf3d705e.png";